<template>
    <div>
        <h1>Personal Info</h1>
        <form
            class="grid"
            novalidate
            @submit.prevent="updatePassword">
            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="UpdateProfileFirstName">First Name</label>
                    <input
                        id="UpdateProfileFirstName"
                        name="UpdateProfileFirstName"
                        placeholder="First Name"
                        type="text"
                        v-model.trim="firstName"
                        v-validate.disable="'required'">
                    <span
                        class="error-message"
                        v-if="errors.has('UpdateProfileFirstName')">{{ errors.first('UpdateProfileFirstName') }}</span>
                </div>
            </div>

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="UpdateProfileLastName">Last Name</label>
                    <input
                        id="UpdateProfileLastName"
                        name="UpdateProfileLastName"
                        placeholder="Last Name"
                        type="text"
                        v-model.trim="lastName"
                        v-validate.disable="'required'">
                    <span
                        class="error-message"
                        v-if="errors.has('UpdateProfileLastName')">{{ errors.first('UpdateProfileLastName') }}</span>
                </div>
            </div>

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="UpdateProfilePhone">Phone Number</label>
                    <input
                        id="UpdateProfilePhone"
                        name="UpdateProfilePhone"
                        placeholder="Phone Number"
                        type="text"
                        v-mask="'(###) ###-####'"
                        v-model.trim="phone"
                        v-validate.disable="'phone'">
                    <span
                        class="error-message"
                        v-if="errors.has('UpdateProfilePhone')">{{ errors.first('UpdateProfilePhone') }}</span>
                </div>
            </div>

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="UpdateProfileEmail">Email Address</label>
                    <input
                        id="UpdateProfileEmail"
                        name="UpdateProfileEmail"
                        placeholder="Email Address"
                        type="email"
                        v-model.trim="email"
                        v-validate.disable="'required|email'">
                    <span
                        class="error-message"
                        v-if="errors.has('UpdateProfileEmail')">{{ errors.first('UpdateProfileEmail') }}</span>
                </div>
            </div>

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <button
                        class="submit"
                        type="submit"
                        :disabled="isUpdating">Update Profile</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import errorHandleable from '../mixins/ErrorHandleable'
import quebecUserModal from '../mixins/QuebecUserModal'
import trackable from '../mixins/Trackable'

export default {
    beforeCreate () {
        this.htmlPageTitle = `Your profile at ${this.$config.partnerName}`
    },
    created () {
        this.trackPageView(this.$route.fullPath, this.htmlPageTitle)
    },
    data () {
        return {
            email: '',
            firstName: '',
            isUpdating: false,
            lastName: '',
            phone: ''
        }
    },
    head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    methods: {
        updatePassword () {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (!isValid) { return null }

                    this.isUpdating = true

                    this.$marketplace
                        .updateProfile(this.$store.state.userProfile.id, {
                            email_address: this.email,
                            first_name: this.firstName,
                            last_name: this.lastName,
                            phone_number: this.phone
                        })
                        .then(response => {
                            if (!response.success) { return Promise.reject(new Error('Invalid response')) }
                            this.$store.commit('setUserProfile', response.account)
                            this.$notify({
                                type: 'success',
                                text: 'Your profile has been updated.'
                            })
                        })
                        .catch(response => this.catchAndNotify(response.errors || response))
                        .finally(() => {
                            this.isUpdating = false
                        })
                })
        }
    },
    mixins: [
        errorHandleable,
        quebecUserModal,
        trackable
    ],
    watch: {
        '$store.state.userProfile': {
            immediate: true,
            handler () {
                this.email = this.$store.state.userProfile.email_address || ''
                this.firstName = this.$store.state.userProfile.first_name || ''
                this.lastName = this.$store.state.userProfile.last_name || ''
                this.phone = this.$store.state.userProfile.phone_number || ''
            }
        }
    }
}
</script>
